module.exports = __webpack_public_path__ + "img/horizontal_3@2x.deff6cec.png";